import React from 'react';
import { CheckIcon } from 'lucide-react';
import { deliverables, deliverablesExtra } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-white py-16 md:py-24" data-id="element-173" data-mp="zyiyvc8b5wmh">
      <div className="mx-auto w-full max-w-3xl px-5 md:px-8" data-id="element-174" data-mp="l4ms3hrsxc1d">
        <header className="text-center" data-id="element-175" data-mp="q269urnpk6y2">
          <p className="text-xs font-extrabold uppercase tracking-widest text-pink-700" data-id="element-176" data-mp="q2y33vtu1sl6">
            In totale trasparenza
          </p>
          <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-neutral-800 md:text-5xl" data-id="element-177" data-mp="1dud0da6r5jpk">
            Ecco esattamente cosa ricevi oggi
          </h2>
        </header>

        <ul className="mt-12 divide-y divide-neutral-200 overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-neutral-200" data-id="element-178" data-mp="140cwfbn7ikif">
          {deliverables.map(item => <li key={item} className="flex items-start gap-4 px-5 py-5 md:px-8" data-id="element-179" data-mp="1wpbj8m29yau2">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-green-600 text-white" data-id="element-180" data-mp="21imncffpcdia">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-181" data-mp="2vg3r3vngdgqc" />
              </span>
              <span className="text-lg leading-snug text-neutral-800" data-id="element-182" data-mp="2qiakj1i8mkpj">{item}</span>
            </li>)}
        </ul>

        <p className="mt-6 text-center text-lg font-extrabold tracking-tight text-pink-700 md:text-xl" data-id="element-183" data-mp="357gh0hpoxwtq">
          {deliverablesExtra}
        </p>
      </div>
    </section>;
}